import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  padding-left: 7px;
`

export const InnerWrapper = styled.div`
  margin-left: auto;
  font-weight: 500;
`
